import React from 'react';
import { CheckUserMint } from '../hooks/fetchData';
import { FlexNfts, TextHead, TextNumber, WrapFrameNfts } from '../styles';

interface TotalWhiteListProps {
    totalWhiteList ?: string
}

const TotalWhiteList = () => {
    const {dataUser } = CheckUserMint();  

    return (
        <WrapFrameNfts>
            <FlexNfts>
                <TextHead>TOTAL WHITELIST SLOTS (NFT SLOTS)</TextHead>
                <TextNumber fontSize='36px'>{dataUser.whitelistCount}</TextNumber>
            </FlexNfts>

            <FlexNfts>
                <TextHead>REMAINING</TextHead>
                <TextNumber fontSize='36px'>{dataUser.leftNfts}</TextNumber>
            </FlexNfts>
        </WrapFrameNfts>
    );
};

export default TotalWhiteList;